import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Select from 'react-select';
import ReactTooltip from 'react-tooltip';

import {
  getIcon,
  getOptionValueForSelect,
} from '../../util';

import {
  fetchUserDataForEveryone
} from '../../actions';

import {
  fetchSprintHistoryForEveryone
} from '../../actions/sprint';

import SprintHistoryItem from './sprintHistoryItem';

class LeaderboardsReport extends Component {

  state = {
    viewingActivity: null,//238912
    userData: {},
  }

  componentDidMount(){
    this.props.fetchSprintHistoryForEveryone();
    this.props.fetchUserDataForEveryone(userData => {
      // console.log('found user data: ', userData);
      this.setState({
        userData: _.keyBy(userData, '_id')
      });
    }, true);
  }

  componentDidUpdate(prevProps, prevState){
    if(!this.state.viewingActivity && _.size(this.activityGoalsForOrg()) > 0){
      this.setState({
        viewingActivity: _.first(_.filter(this.props.organization.sprintGoals, { category: 'activity' })).id
      });
    }
  }

  userData(userId){
    return this.state.userData[userId];
  }

  activityGoalsForOrg(){
    return _.filter((this.props.organization || {}).sprintGoals || [], { category: 'activity' });
  }

  renderActivitySelect(){
    const activityOptions = _.map(this.activityGoalsForOrg(), goal => {
      return {
        label: goal.name,
        value: goal.id
      }
    });

    const { viewingActivity } = this.state;

    if(activityOptions && _.size(activityOptions) > 0){
      return (
        <Select
          placeholder="Select..."
          classNamePrefix={'react-select'}
          className='react-select-container activity-select'
          value={getOptionValueForSelect(activityOptions, viewingActivity)}
          options={activityOptions}
          onChange={(option) => { this.setState({ viewingActivity: option.value }); }}
          isSearchable={true}
        />
      )
    }
    else{
      return null;
    }
  }

  getHistoryRowWithOffset(offset = 0){

    const startDate = moment().startOf('isoWeek').subtract(offset, 'weeks');
    const endDate = moment().endOf('isoWeek').subtract(offset, 'weeks').subtract(2, 'days');//friday

    return {
      startDate,
      endDate,
      startLabel: startDate.format('M/D'),
      endLabel: endDate.format('M/D'),
    }
  }

  getCurrentActivityItemRows(){
    return _.map(_.reverse([1,2,3,4,5,6,7,8,9,10]), this.getHistoryRowWithOffset.bind(this));
  }

  renderNoActivity(){
    return (
      <div className="activity-item no-match">{getIcon('times')}</div>
    )
  }

  activityCompletionForSprint(sprintHistory){
    if(!sprintHistory || !sprintHistory.goals || !_.find(sprintHistory.goals, { id: this.state.viewingActivity })){
      return 0;
    }
    else{
      const goalValue = _.find(sprintHistory.goals, { id: this.state.viewingActivity }).goalValue;
      return !isNaN(parseInt(goalValue)) ? parseInt(goalValue) : 0;
    }
  }

  renderActivityForWeek(sprint){

    const completion = this.activityCompletionForSprint(sprint);

    if(!completion){
      return this.renderNoActivity();
    }

    const wonTheWeek = completion >= this.maxCompletionForWeek(sprint.startDate, sprint.endDate);

    return (
      <div key={`sprint-history-id-${sprint._id}`} className={`activity-item ${wonTheWeek ? 'won-the-week' : ''}`}>
        <div className="amount">{completion}</div>
        <div className="context-icon">{getIcon('trophy')}</div>
      </div>
    )
  }

  totalActivityCompletionForUser(user){
    const userSprints = _.filter(this.props.sprintHistory, { userId: user._id });

    const tenWeeksAgoStartDate = this.getHistoryRowWithOffset(10).startDate;
    const latestWeekEndDate = this.getHistoryRowWithOffset(1).endDate;

    const userSprintsForLastTenWeeks = _.filter(userSprints, sprint => {
      return moment(sprint.startDate).diff(tenWeeksAgoStartDate) >= 0 &&
            moment(sprint.endDate).diff(latestWeekEndDate) <= 0;
      ;
    });

    return _.reduce(userSprintsForLastTenWeeks, (memo, sprint) => {
      return memo + this.activityCompletionForSprint(sprint);
    }, 0);
  }

  renderTotalActivityForUser(user, index){

    const totalCompletion = this.totalActivityCompletionForUser(user);

    if(!totalCompletion){
      return this.renderNoActivity();
    }

    return (
      <div className={`activity-item ${index === 0 ? 'won-the-week' : ''}`}>
        <div className="amount">{totalCompletion}</div>
        <div className="context-icon">{getIcon('trophy')}</div>
      </div>
    )
  }

  renderActivityItemColumnHeaders(){
    return (
      <div className="activity">
        {_.map(this.getCurrentActivityItemRows(), rowData => {
          return (
            <div key={`column-heading-for-row-${rowData.startLabel}`} className="activity-column-heading">
              <div className="start-label">{rowData.startLabel}</div>
              <div className="end-label">{rowData.endLabel}</div>
            </div>
          );
        })}
        <div className="activity-column-heading">
          <div className="total-label">TOTAL</div>
        </div>
      </div>
    )
  }

  maxCompletionForWeek(startDate, endDate){
    let max = 0;

    const matchingSprintHistory = _.filter(this.props.sprintHistory, item => {
      return  item.startDate === startDate &&
              item.endDate === endDate
    });

    _.each(matchingSprintHistory, sprint => {
      const completion = this.activityCompletionForSprint(sprint);
      if(completion && completion > max){
        max = completion
      }
    });

    return max;
  }

  renderActivityRowForUser(user, index){

    const {
      sprintHistory
    } = this.props;

    if(!user || !sprintHistory){
      return null;
    }

    const currentActivityItemRows = this.getCurrentActivityItemRows();

    return (
      <div key={user._id} className={`row member ${index === 0 ? 'leader' : ''} ${user._deleted ? 'archived' : ''}`}>
        <div className="name">{user.firstName} {user.lastName}<div className="place">{index > 0 ? `#${index + 1}` : 'LEADER'}</div></div>
        <div className="activity">
          {_.map(currentActivityItemRows, rowData => {

            const matchingSprintHistory = _.find(sprintHistory, item => {
              // console.log('checking sprintHistory.userId', memberId, item.userId);
              // console.log('checking startDate: ', item.startDate, rowData.startDate.format('YYYYMMDD'));
              // console.log('checking endDate: ', item.startDate, rowData.endDate.format('YYYYMMDD'));

              return  item.userId === user._id &&
                      item.startDate === rowData.startDate.format('YYYYMMDD') &&
                      item.endDate === rowData.endDate.format('YYYYMMDD');
            });

            return this.renderActivityForWeek(matchingSprintHistory);

          })}
          {this.renderTotalActivityForUser(user, index)}
        </div>
      </div>
    )
  }

  renderLeaderboardForCurrentActivity(){

    const usersWithActivity = _.filter(this.state.userData, user => {
      return this.totalActivityCompletionForUser(user) > 0;
    });

    const sortedUsers = _.sortBy(usersWithActivity, user => {
      return -1 * this.totalActivityCompletionForUser(user);
    });

    const selectedActivity = _.find(this.activityGoalsForOrg(), { id: this.state.viewingActivity });

    return (
      <div className="activity-leaderboards">
        <div className="row meta">
          <div className="name">{selectedActivity ? selectedActivity.name : 'Loading...'}</div>
          {this.renderActivityItemColumnHeaders()}
        </div>
        {_.map(sortedUsers, this.renderActivityRowForUser.bind(this))}
      </div>
    )
  }

  showLegend(){
    this.setState({
      showingLegend: true
    });
  }

  render(){

    const { showingLegend } = this.state;

    return (
      <div className="report leaderboards">
        {this.renderActivitySelect()}
        {this.renderLeaderboardForCurrentActivity()}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    organization: state.organization.data,
    sprintHistory: state.sprintHistory.data,
    fetchingSprintHistory: state.sprintHistory.loading,
    teams: state.teams.data,
  }
}

export default connect(mapStateToProps, { fetchSprintHistoryForEveryone, fetchUserDataForEveryone })(LeaderboardsReport);



// WEBPACK FOOTER //
// ./src/components/reports/leaderboards.js